import { render, staticRenderFns } from "./ExtendExpiration.vue?vue&type=template&id=1037e0ec&scoped=true&"
import script from "./ExtendExpiration.vue?vue&type=script&lang=ts&"
export * from "./ExtendExpiration.vue?vue&type=script&lang=ts&"
import style0 from "./ExtendExpiration.vue?vue&type=style&index=0&id=1037e0ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1037e0ec",
  null
  
)

export default component.exports